<template>
  <div
    class="crtvup-text-book-reader"
    :class="[
      !showNavbar ? 'do-not-display-nav-bar' : '',
      'crtvup-text-book-reader-' + pageType,
    ]"
  >
    <xml-digital-teaching
      v-if="digitalTeaching"
      ref="xmlDigitalTeaching"
      :textBookData="textBookData"
      :catalogList="catalogList"
      :looseLeafData="looseLeafData"
      :location="location"
      :notesList="notesList"
      :bookmarkList="bookmarkList"
      :textDomList="contentList"
      :continueReading="continueReading"
      :isTrial="isTrial"
      :isTrialIndex="isTrialIndex"
      :testPaperPath="testURL"
      @updateReadLocation="updateReadLocation"
      @confirm="confirm"
      @updateNotes="updateNotes"
      @deleteNotes="deleteNotes"
      @addBookmark="addBookmark"
      @deleteBookmark="deleteBookmark"
      @downloadFile="downloadFile"
      :basisPath="basisPath"
      :pageType="pageType"
      :trialText="trialText"
      :trialPrompt="trialPrompt"
      :isShowAi="textBookData.showAi"
      @setanalysis="setanalysis"
    />
    <xml-robot
      ref="xmlRobot"
      :bookName="textBookData.textBooksName"
      v-if="textBookData.showAi == '0' && pageType != 'pc'"
    />
    <robot
      ref="robot"
      :bookName="textBookData.textBooksName"
      v-if="textBookData.showAi == '0' && pageType == 'pc'"
    />

    <iframe
      v-if="src"
      :src="src"
      frameborder="0"
      class="iframe"
      id="iframe"
    ></iframe>
  </div>
</template>

<script>
import xmlRobot from "@/components/xmlRobot/xmlRobot";
import robot from "@/components/robot.vue";
import {
  getTextBookInfo,
  getTextBookCatalog,
  getTextBookLooseLeaf,
  getLeaf,
} from "@/api/looseleaf/looseleaf";
import { getCatalogInfoById } from "@/api/mobileterminalread/index";
import {
  insertNote,
  update,
  selectNoteListByFileId,
  removeNoteById,
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
  selectReadInfo, //获取阅读时长
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  updateOcReadSchedule, //更新阅读进度
} from "@/api/special/special";
import { testURL } from "@/utils/config";
import { getToken, setToken } from "@/utils/auth";
import { createPreviewSrc } from "@/api/looseleaf/looseleaf";
import { looseleafGetToken } from "@/api/index/index";
export default {
  components: { xmlRobot,robot },
  data() {
    return {
      digitalTeaching: false,
      goodsId: "",
      textBookData: {},
      catalogList: [],
      looseLeafData: {},
      trialText: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      trialPrompt: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      location: "",
      continueReading: false,
      basisPath: "",
      notesList: [],
      bookmarkList: [],
      pageType: "pc",
      contentList: [],
      isTrial: false,
      isTrialIndex: 10,
      textBookId: "",
      isShow: "",
      showRobot: true,
      testURL: testURL,
      showNavbar: true,
      TimeParameter: null,
      operationalState: 0,
      src: "",
      robotBook: {
        "1694952726309507072": {
          name: "三秦文化概论",
        },
        "1674758026424356864": {
          name: "药事管理与法规（第2版）",
        },
        "1686915284222480384": {
          name: "建筑构造",
        },
        "1613418196050776064": {
          name: "药事管理与法规",
        },
        "1669152756075728896": {
          name: "建筑构造（第3版）",
        },
        "1737393327818543104": {
          name: "建筑工程质量检验案例分析",
        },
      },
    };
  },
  created() {
    let router = this.$route.query;
    this.goodsId = router.goodsId || "";
    this.continueReading = router.continueReading == "true" ? true : false;
    this.isTrial = router.isTrial == "true" ? true : false;
    if (this.$route.query.ysyWebToken) {
      console.log(this.$route.query.ysyWebToken);
      setToken(this.$route.query.ysyWebToken);
      setTimeout(() => {
        console.log("getToken", getToken());
        if (this.textBookId == "1655372241083891712") {
          looseleafGetToken().then((res) => {
            let data = {
              token: getToken(),
              pageType: this.pageType,
              businessType: router.businessType,
              looseLeafId: "",
              textBookId: "",
              isTrial: this.isTrial,
            };
            if (router.businessType == "textBook") {
              data.textBookId = this.textBookId;
            } else {
              data.looseLeafId = this.catalogId;
            }
            createPreviewSrc(data).then((res) => {
              if (res.code == 200) {
                this.src = res.data;
              }
            });
          });
        }
        this.getNotesList("note");
        this.getNotesList("bookmark");
        this.getFileLocation();
        this.selectTimeParameter();
      }, 1000);
    } else if (getToken()) {
      this.getNotesList("note");
      this.getNotesList("bookmark");
      this.getFileLocation();
      this.selectTimeParameter();
    }

    if (router.textBookId) {
      this.textBookId = router.textBookId;
    }
    this.showNavbar = router.showNavbar == "0" ? false : true;
    if (router.pageType) {
      this.pageType = router.pageType;
    }

    if (router.catalogId) {
      this.catalogId = router.catalogId;
      getCatalogInfoById({ catalogId: router.catalogId }).then((res) => {
        this.queryData(res.data);
      });
    } else if (
      router.businessType == "textBook" &&
      this.textBookId != "1655372241083891712"
    ) {
      getTextBookInfo(this.textBookId).then((res) => {
        this.textBookData = res.data;
        this.$emit("getbookinfo", this.textBookData);
      });
      getTextBookCatalog(this.textBookId, "1").then((res) => {
        this.catalogList = res.data;
      });
      getTextBookLooseLeaf(this.textBookId).then((res) => {
        this.looseLeafData = JSON.parse(res.msg);
        setTimeout(() => {
          this.digitalTeaching = true;
        }, 500);
      });
    } else if (router.businessType == "looseLeaf") {
      getLeaf(this.textBookId).then((res) => {
        this.textBookData = res.data;
        this.catalogList = [
          {
            children: [],
            hiddenFlag: "0",
            id: this.textBookId,
            label: res.data.looseLeafName,
            level: null,
            orderNum: 0,
            parentId: null,
            uploadFileUrl: "",
          },
        ];

        let looseLeafData = {};
        looseLeafData[this.textBookId] = res.data;

        this.looseLeafData = {
          ...looseLeafData,
        };
        setTimeout(() => {
          this.digitalTeaching = true;
        }, 500);
      });
    }
  },

  mounted() {},
  methods: {
    // 确认添加笔记
    confirm(e) {
      let chapterId = e.location.split("/")[1];
      let keycode = {
        keyid: e.keyid,
        ...e.keycode,
        location: e.location,
        chapterId: chapterId,
      };
      let data = {
        goodsId: this.goodsId,
        goodsFileId: this.goodsId,
        originalText: e.htmltext,
        textRange: JSON.stringify(keycode),
        href: e.location,
        noteContent: e.remarks,
        type: "note",
      };
      insertNote(data).then(() => {
        this.$refs.xmlDigitalTeaching.showToast("添加成功", "success");
        this.getNotesList("note");
        // 添加笔记成功后显示笔记标记
        this.$refs.xmlDigitalTeaching.notesSign(e, "add");
      });
    },

    // 更新笔记
    updateNotes(e) {
      let chapterId = e.location.split("/")[1];
      let keycode = {
        keyid: e.keyid,
        ...e.keycode,
        location: e.location,
        chapterId: chapterId,
      };
      let data = {
        id: e.id,
        goodsId: this.goodsId,
        goodsFileId: this.goodsId,
        originalText: e.htmltext,
        textRange: JSON.stringify(keycode),
        href: e.location,
        noteContent: e.remarks,
        type: "note",
      };
      update(data).then((response) => {
        if (response.code == 200) {
          this.$refs.xmlDigitalTeaching.showToast("更新成功", "success");
          this.getNotesList("note");
          // 添加笔记成功后显示笔记标记
          this.$refs.xmlDigitalTeaching.notesSign(e, "update");
        }
      });
    },

    // 删除笔记
    deleteNotes(e) {
      console.log("🚀 ~ deleteNotes ~ e:", e);
      removeNoteById(e.id).then((response) => {
        this.$refs.xmlDigitalTeaching.showToast("删除成功", "success");
        this.getNotesList("note");
        // 添加笔记成功后显示笔记标记
        this.$refs.xmlDigitalTeaching.notesSign(e, "remove");
      });
    },

    // 添加书签
    addBookmark(e) {
      console.log("🚀 ~ addBookmark ~ e:", e);
      let chapterId = e.location.split("/")[1];
      let keycode = {
        keyid: e.keyid,
        ...e.keycode,
        location: e.location,
        chapterId: chapterId,
      };
      let data = {
        goodsId: this.goodsId,
        goodsFileId: this.goodsId,
        originalText: e.text,
        textRange: JSON.stringify(keycode),
        href: e.location,
        noteContent: e.remarks,
        type: "bookmark",
      };
      insertNote(data).then(() => {
        this.$refs.xmlDigitalTeaching.showToast("添加成功", "success");
        this.getNotesList("bookmark");
        // 添加书签成功后显示书签标记
        this.$refs.xmlDigitalTeaching.bookmarkSign(e, "add");
      });
    },

    // 删除书签
    deleteBookmark(e) {
      console.log("🚀 ~ deleteBookmark ~ e:", e);
      removeNoteById(e.id).then((response) => {
        this.$refs.xmlDigitalTeaching.showToast("删除成功", "success");
        this.getNotesList("bookmark");
        // 添加书签成功后显示书签标记
        this.$refs.xmlDigitalTeaching.bookmarkSign(e, "remove");
      });
    },

    // 获取笔记列表 type: note笔记 bookmark书签
    getNotesList(type) {
      selectNoteListByFileId(this.goodsId, type).then((res) => {
        let list = res.data || [];
        list.map((item) => {
          let keycode = JSON.parse(
            item.textRange.replace(new RegExp('\\\\"', "gm"), '"')
          );
          this.$set(item, "endTag", keycode.endMeta.parentTagName);
          this.$set(item, "endTagIndex", keycode.endMeta.parentIndex);
          this.$set(item, "endTextOffset", keycode.endMeta.textOffset);
          this.$set(item, "startTag", keycode.startMeta.parentTagName);
          this.$set(item, "startTagIndex", keycode.startMeta.parentIndex);
          this.$set(item, "startTextOffset", keycode.startMeta.textOffset);
          this.$set(item, "keycode", keycode);
          this.$set(item, "keyid", keycode.keyid);
          this.$set(item, "htmltext", item.originalText);
          this.$set(item, "text", item.originalText);
          this.$set(item, "remarks", item.noteContent);
          this.$set(item, "location", keycode.location);
          this.$set(item, "chapterId", keycode.chapterId);
        });
        if (type == "note") {
          this.notesList = list;
        } else if (type == "bookmark") {
          this.bookmarkList = list;
          console.log("this.bookmarkList", this.bookmarkList);
        }
      });
    },

    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;

        this.setInterval2 = setInterval(() => {
          this.operationalState++;
          if (this.operationalState < 60) {
            this.updateOcDownloadReading(); //更新阅读时长
          }
        }, this.TimeParameter * 60000);
      });
    },

    // 更新阅读进度
    updateOcReadSchedule(data) {
      updateOcReadSchedule({
        fileId: this.goodsId,
        readingLocation: data.location,
        schedule: data.schedule,
      }).then((res) => {});
    },

    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.goodsId || "",
        goodsId: this.$route.query.goodsId || "",
        relevanceId: this.$route.query.relevanceId || "",
        resource: this.$route.query.resource || "",
        resourceType: this.$route.query.resourceType || "",
        teachInstId: this.$route.query.teachInstId || "",
      }).then((res) => {});
    },

    // 获取阅读文件地址和文件进度
    getFileLocation() {
      selectFileLinkAndReadingLocation({
        goodsFileId: this.goodsId || "",
        goodsId: this.$route.query.goodsId || "",
        relevanceId: this.$route.query.relevanceId || "",
        resource: this.$route.query.resource || "",
        resourceType: this.$route.query.resourceType || "",
        teachInstId: this.$route.query.teachInstId || "",
      }).then((res) => {
        this.location = res.data.readingLocation;
      });
    },

    // 下载资源文件
    downloadFile(e) {},

    // 更新阅读进度
    updateReadLocation(newLocation) {
      this.operationalState = 0;
      this.updateOcReadSchedule(newLocation); //更新阅读时长
    },
    //AI解析
    setanalysis(data) {
      console.log(data);
      if (this.textBookData.showAi == "0" && this.pageType != "pc") {
        this.$refs.xmlRobot.show = true;
          this.$refs.xmlRobot.sendingMsg(data.value.replace(/&nbsp;/gi, ""));
      }else if(this.textBookData.showAi == "0" && this.pageType == "pc"){
        
        this.$refs.robot.robotShwo = true;
          this.$refs.robot.sending(data.value.replace(/&nbsp;/gi, ""));
      }
    },

    queryData(data) {
      let bookInfo = {};

      const getItemByChild = (list, label) => {
        for (let i = 0; i < list.length; i++) {
          this.$set(list[i], "label", list[i].catalogName);
          let it = list[i];
          bookInfo[it.id] = it;
          if (it.children) {
            getItemByChild(it.children);
          }
        }
        this.looseLeafData = bookInfo;
        if (data[0].children?.length > 0) {
          for (let i = 0; i < data[0].children.length; i++) {
            this.$set(data[0].children[i], "hiddenFlag", "1");
          }
        }
        setTimeout(() => {
          this.digitalTeaching = true;
          this.catalogList = data;
        }, 500);
      };
      getItemByChild(data);
    },
  },
};
</script>

<style lang="scss">
.crtvup-text-book-reader-pc {
  .ouchn-container.preview-mode
    .preview-for-pc
    .pc-container
    .preview-screen-pc {
    max-width: 700px;
  }
  .ouchn-container.preview-mode
    .preview-container-title-pc
    .container-iocn-search-pc {
    top: 15px;
  }
  .xml-single-question-group-pc {
    .shop-item-img {
      img {
        width: 100%;
      }
    }
  }
  .ouchn-container .parent-group {
    padding: 16px 50px;
  }
  // .tab-title-pc {
  //   display: none;
  // }
  .xml-single-question-group-pc {
    .group-content-box {
      .stem-box {
        display: flex;
        .question-number {
          padding-right: 4px;
          line-height: 28px;
        }
      }
    }
  }
}
.do-not-display-nav-bar {
  .ouchn-container.preview-mode
    .preview-for-pc
    .pc-container
    .preview-screen-pc {
    max-width: 700px;
  }
  .ouchn-container .parent-group {
    padding: 16px 30px;
  }
  .preview-container-title-pc {
    display: none !important;
  }
  .pc-catalog.pc-catalog--render {
    margin-top: 0 !important;
    height: calc(100vh - 6px) !important;
  }
  .ouchn-container.preview-mode .preview-tree-box-pc.custom-catalog-tree {
    height: calc(100vh - 46px) !important;
  }
  .tab-title-pc {
    top: 0 !important;
  }
  .preview-list-counter-pc {
    margin: 0 auto 40px auto !important;
    height: calc(100vh - 46px) !important;
    padding-top: 0 !important;
  }
  .preview-list-pc {
    height: 100vh !important;
  }
  .tab-title-pc {
    display: none !important;
  }
  .add-notes-bookmarks-pc {
    display: none !important;
  }
}
.iframe {
  width: 100%;
  height: 100%;
  height: calc(100vh - 60px);
}
.xml-viewer__wrapper .phone-preview .preview-list-counter::-webkit-scrollbar {
  width: 0 !important;
}
</style>
